<template>
  <div class="product">
    <div class="product-list" v-for="(item, index) in resDatas">
      <div class="title">
        {{ item.title }}
      </div>
      <div class="product-main">
        <div class="product-banner">
          <img
            :src="require('../assets/images/list-img' + index + '.jpg')"
            alt=""
          />
        </div>
        <div class="product-text" v-html="item.gameIntro"></div>
        <div class="product-download">
          <p class="download-title">PLATFORMS</p>
          <div class="download-box">
            Coming Soon…
            <!-- <a><img src="~@/assets/images/ios.png" alt=""></a>
            <a><img src="~@/assets/images/google.png" alt=""></a> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      resDatas: "",
    };
  },
  props: {
    resData: {},
  },
  watch: {
    resData(newData) {
      this.resDatas = newData;
    },
  },
  methods: {},
  mounted() {
    this.$parent.getlan();
  },
};
</script>

<style scoped>
.product {
  width: 50%;
  margin: auto;
  box-sizing: border-box;
  padding-top: 3%;
}
.product-list {
  padding: 2%;
  background-color: white;
}
.product-list:nth-of-type(1) {
  margin-bottom: 2%;
}
.title {
  font-size: 20px;
  font-weight: 600;
  color: #57749c;
  padding: 2% 3%;
  border-bottom: 1px solid #57749c;
}
.product-main {
}
.product-banner {
  padding: 2%;
}
.product-banner img {
  width: 100%;
  display: block;
}
.product-text {
  font-size: 16px;
  word-break: break-all;
}
.product-download {
  background-color: #e7ebf1;
  padding: 1.5% 2%;
  margin-top: 1%;
}
.product-download .download-title {
  color: #5b6e88;
  font-size: 20px;
  text-align: center;
  background-color: white;
  padding: 1% 0;
  font-weight: 600;
}
.download-box {
  font-size: 20px;
  text-align: center;
  padding: 1% 0 0;
}
.download-box a {
  display: inline-block;
  cursor: pointer;
  width: 15%;
  margin: 1% 1% 0;
}
.download-box a img {
  width: 100%;
  display: block;
}
@media screen and (max-width: 1000px) {
  .product {
    width: 95%;
  }
  .product-list {
    padding: 2% 2% 3%;
    background-color: white;
  }
  .product-list:nth-of-type(1) {
    margin-bottom: 3%;
  }
  .product-download {
    padding: 3%;
  }
  .download-box a {
    margin: 3% 3% 0;
    width: 34%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/product.vue